import { render, staticRenderFns } from "./trainingService.vue?vue&type=template&id=bf437a52&scoped=true&"
import script from "./trainingService.js?vue&type=script&lang=js&"
export * from "./trainingService.js?vue&type=script&lang=js&"
import style0 from "./trainingService.css?vue&type=style&index=0&id=bf437a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf437a52",
  null
  
)

export default component.exports